import React from "react"
import {UxCTA as CTA} from "@next/ux-cta"
import UxToolTip from "@next/ux-tooltip"
import {MyAccountLoggedInTooltipProps} from "../.."
import LoggedInTooltipUsername from "../../../MyAccountLoggedInTooltipUsername"
import Icon from "../../../Icon"

import {NO_FOLLOW} from "../../../../config/constants"
import {removeDeptFromSessionStorage} from "../../../../utils/removeDeptFromSessionStorage"
import {ToolTipTitle} from "../../component"
import {
    DividerStyled,
    SignoutButtonStyled,
    ToolTipContentStyled,
    TooltipFooterStyled,
    TooltipHeaderStyled,
    ToolTipUsernameStyled,
    ViewAccountSummaryLinkStyled,
} from "./component"

export const loggedinTooltipTestid = (el?: string) => `header-my-account-container${el ? `-${el}` : ""}`

export const LoggedInTooltip = ({
    open,
    anchorEl,
    handleClose,
    tooltipIcon,
    accessibilityText,
    url,
    text,
    firstName,
    signoutUrl,
    placement,
    enableModArrow,
}: MyAccountLoggedInTooltipProps) => {
    return (
        <UxToolTip
            open={open}
            ref={anchorEl}
            handleClose={handleClose}
            animationTimeout={300}
            placement={placement}
            enableModArrow={enableModArrow}
            showHeader
            modifiers={[
                {
                    name: "offset",
                    options: {
                        enabled: true,
                        offset: [0, 7],
                    },
                },
                {
                    name: "arrow",
                    options: {
                        padding: "5rem",
                    },
                },
            ]}
        >
            <ToolTipContentStyled data-testid={loggedinTooltipTestid()}>
                <TooltipHeaderStyled>
                    <ViewAccountSummaryLinkStyled
                        onClick={removeDeptFromSessionStorage}
                        data-testid={loggedinTooltipTestid("tooltip-link")}
                    >
                        <Icon src={tooltipIcon} alt={accessibilityText} />
                        <ToolTipTitle>
                            <a href={url} rel={NO_FOLLOW} data-testid={loggedinTooltipTestid("tooltip-title")}>
                                {text.title}
                            </a>
                        </ToolTipTitle>
                    </ViewAccountSummaryLinkStyled>
                </TooltipHeaderStyled>
                <DividerStyled />
                <TooltipFooterStyled>
                    <ToolTipUsernameStyled>
                        <LoggedInTooltipUsername notText={text.notText as string} firstName={firstName as string} />
                    </ToolTipUsernameStyled>
                    <SignoutButtonStyled data-testid={loggedinTooltipTestid("tooltip-signout")}>
                        <CTA
                            color="secondary"
                            state="enabled"
                            variant="outlined"
                            size="medium"
                            url={signoutUrl}
                            text={text.buttonText}
                        />
                    </SignoutButtonStyled>
                </TooltipFooterStyled>
            </ToolTipContentStyled>
        </UxToolTip>
    )
}
export default LoggedInTooltip
